import * as React from "react"

const SvgArrowUpMini = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 16 16"
    {...props}
  >
    <path d="M7.5 5.82V13q0 .424.288.712.287.288.712.288c.425 0 .52-.096.713-.288A.97.97 0 0 0 9.5 13V5.82l2.9 2.9a.95.95 0 0 0 .7.275.95.95 0 0 0 .7-.275.95.95 0 0 0 .275-.7.95.95 0 0 0-.275-.7l-4.6-4.6a.96.96 0 0 0-.7-.3q-.4 0-.7.3l-4.6 4.6a.95.95 0 0 0-.275.7.95.95 0 0 0 .275.7.95.95 0 0 0 .7.275.95.95 0 0 0 .7-.275z" />
  </svg>
)
export default SvgArrowUpMini
